import { render, staticRenderFns } from "./FormLampiranAngkaKreditSKP.vue?vue&type=template&id=624a9a02&lang=html&"
import script from "./FormLampiranAngkaKreditSKP.vue?vue&type=script&lang=js&"
export * from "./FormLampiranAngkaKreditSKP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports